import { render } from "./WorkerCard.vue?vue&type=template&id=a35828a4&ts=true"
import script from "./WorkerCard.vue?vue&type=script&lang=ts"
export * from "./WorkerCard.vue?vue&type=script&lang=ts"

import "./WorkerCard.vue?vue&type=style&index=0&id=a35828a4&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__